"use client";

import type { ReactNode } from "react";
import ThemeAttributes from "@/app/theme/ThemeAttributes";

interface ThemeWrapperProps {
	children: ReactNode;
}

/**
 * What used to be MUI's <ThemeProvider> tree. Each piece it wrapped now lives
 * somewhere that does not depend on MUI:
 *
 *  - ThemeProvider  -> ThemeAttributes writes `.dark` on <html>, and colors.css
 *                      swaps the palette off it.
 *  - CssBaseline    -> Tailwind's preflight, plus the `body` rule in globals.css.
 *  - GlobalStyles   -> the transition rule in globals.css.
 *  - RTL            -> that wrapper only flipped emotion-generated MUI styles,
 *                      so it had nothing left to do. The direction setting that
 *                      went with it is gone too: see ThemeAttributes.
 */
export const ThemeWrapper = ({ children }: ThemeWrapperProps) => {
	return (
		<>
			<ThemeAttributes />
			{children}
		</>
	);
};
